import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=4a3278ed"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a3278ed')) {
      api.createRecord('4a3278ed', component.options)
    } else {
      api.reload('4a3278ed', component.options)
    }
    module.hot.accept("./Greeting.vue?vue&type=template&id=4a3278ed", function () {
      api.rerender('4a3278ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/Header/Greeting.vue"
export default component.exports